// Bepaalt onder welk pad een bestand in de opslag terechtkomt.
//
// Zonder map blijft het gedrag zoals het was: het bestand belandt in de
// hoofdmap onder zijn eigen naam. Dat is bewust — de onFinalize-functie
// `embedPortfolioDocument` zoekt het bijbehorende Firestore-doc op via precies
// dat pad, dus verplaatsen zou die koppeling stil verbreken.
// Met een map krijgt het bestand een uuid ervoor, zodat twee mensen met een
// gelijknamig bestand elkaar niet overschrijven.
// AI-CONTEXT: See docs/inbox.md #122
import { v4 as uuid } from 'uuid';

/**
 * @param {string} fileName - Naam van het gekozen bestand
 * @param {string} [folder] - Map in de opslag; leeg = hoofdmap, oude gedrag
 * @param {() => string} [newId] - Alleen voor tests: vervangt de uuid-generator
 * @returns {string} het volledige opslagpad
 */
const buildUploadPath = (fileName, folder, newId = uuid) => {
    const name = fileName || 'bestand';
    if (!folder) return name;

    const cleanFolder = folder.replace(/^\/+|\/+$/g, '');
    return `${cleanFolder}/${newId()}-${name}`;
};

export default buildUploadPath;
